import { takeLatest } from 'redux-saga/effects';

import { userNotificationsWebSocket } from 'redux/modules/userNotifications';

import { GET_PATIENT_DOCUMENT_SUCCESS } from 'redux/modules/patientsDocuments';

// Actions
export const CLEAR_USER_NOTIFICATIONS_HISTORY = 'CLEAR_USER_NOTIFICATIONS_HISTORY';
export const FETCH_USER_NOTIFICATIONS_HISTORY = 'FETCH_USER_NOTIFICATIONS_HISTORY';
export const FETCH_USER_NOTIFICATIONS_HISTORY_SUCCESS = 'FETCH_USER_NOTIFICATIONS_HISTORY_SUCCESS';
export const FETCH_USER_NOTIFICATIONS_HISTORY_FAIL = 'FETCH_USER_NOTIFICATIONS_HISTORY_FAIL';

let userNotificationsHistoryTriggerLoading = false;
let userNotificationsHistoryPush = false;
let userNotificationsHistoryPatientNotifications = false;
let userNotificationsHistoryFilteredByPatient = false;

// Reducer
export default function userNotificationsHistoryReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_USER_NOTIFICATIONS_HISTORY:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_USER_NOTIFICATIONS_HISTORY_SUCCESS:
      if (userNotificationsHistoryPush) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.Notifications.slice(0, payload.data.length),
        ];
        return {
          ...state,
          data: newData,
          ...userNotificationsHistoryTriggerLoading ? { loading: state.loading - 1 } : {},
          count: payload.data['Full Count'],
          filterCount: payload.data['Filter Count'],
        };
      }
      if (userNotificationsHistoryPatientNotifications) {
        return {
          ...state,
          data: state.data.map((dataItem) => {
            if (dataItem.Patient['Record Number'] === payload.data.Notifications[0].Patient['Record Number']) {
              return {
                ...dataItem,
                'Patient Notifications': payload.data.Notifications.slice(1),
              };
            }
            return dataItem;
          }),
        };
      }
      if (userNotificationsHistoryFilteredByPatient) {
        return {
          ...state,
          data: [{
            ...payload.data.Notifications[0],
            Count: payload.data.Notifications.length,
            'Patient Notifications': payload.data.Notifications.slice(1),
          }],
          ...userNotificationsHistoryTriggerLoading ? { loading: state.loading - 1 } : {},
          count: payload.data['Full Count'],
          filterCount: payload.data['Filter Count'],
        };
      }
      return {
        ...state,
        data: payload.data.Notifications,
        ...userNotificationsHistoryTriggerLoading ? { loading: state.loading - 1 } : {},
        count: payload.data['Full Count'],
        filterCount: payload.data['Filter Count'],
      };
    case FETCH_USER_NOTIFICATIONS_HISTORY_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_USER_NOTIFICATIONS_HISTORY:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case GET_PATIENT_DOCUMENT_SUCCESS: {
      const newData = state.data.map((dataItem) => ({
        ...dataItem,
        ...dataItem.Meta['Document ID'] && dataItem.Meta['Document ID'] === payload.ID ? {
          Meta: {
            ...dataItem.Meta,
            ...payload,
          },
        } : {},
        ...dataItem['Patient Notifications'] ? { 'Patient Notifications': dataItem['Patient Notifications'].map(patientNotificationsItem => ({
          ...patientNotificationsItem,
          ...patientNotificationsItem.Meta['Document ID'] && patientNotificationsItem.Meta['Document ID'] === payload.ID ? {
            Meta: {
              ...patientNotificationsItem.Meta,
              ...payload,
            },
          } : {},
        }))} : {},
      }));
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function fetchUserNotificationsHistory(payload) {
  return { type: FETCH_USER_NOTIFICATIONS_HISTORY, payload };
}

export function fetchUserNotificationsHistorySuccess(payload) {
  return { type: FETCH_USER_NOTIFICATIONS_HISTORY_SUCCESS, payload };
}

export function fetchUserNotificationsHistoryFail(payload) {
  return { type: FETCH_USER_NOTIFICATIONS_HISTORY_FAIL, payload };
}

export function clearUserNotificationsHistory() {
  return { type: CLEAR_USER_NOTIFICATIONS_HISTORY };
}

// Sagas
function* fetchUserNotificationsHistorySaga(action) {
  const { triggerLoading, patientNotifications, push = false, filters, limit, offset } = action.payload;
  if (triggerLoading) {
    userNotificationsHistoryTriggerLoading = triggerLoading;
  }
  if (patientNotifications) {
    userNotificationsHistoryPatientNotifications = true;
  } else {
    userNotificationsHistoryPatientNotifications = false;
  }
  if (filters && filters['Patient ID']) {
    userNotificationsHistoryFilteredByPatient = true;
  } else {
    userNotificationsHistoryFilteredByPatient = false;
  }
  userNotificationsHistoryPush = push;
  userNotificationsWebSocket.loadingNotificationsHistory = true;
  userNotificationsWebSocket.send(JSON.stringify({
    load_read_notifications: {
      ...filters && filters.length > 0 ? { filters } : {},
      limit,
      offset,
    },
  }));
}

export function* userNotificationsHistorySaga() {
  yield takeLatest(FETCH_USER_NOTIFICATIONS_HISTORY, fetchUserNotificationsHistorySaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/userNotificationsHistory.js